import { render, staticRenderFns } from "./ImageSettings.vue?vue&type=template&id=5a83c49b&scoped=true&"
import script from "./ImageSettings.vue?vue&type=script&lang=ts&"
export * from "./ImageSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a83c49b",
  null
  
)

export default component.exports